import { combineReducers } from 'redux';
import dasboardReducer from './dasboardReducer';

const roootReducers = combineReducers({
  dasboardReducer,
});

export default roootReducers;
